import { render, staticRenderFns } from "./SurveyListTable.vue?vue&type=template&id=20452279&scoped=true"
import script from "./SurveyListTable.vue?vue&type=script&lang=js"
export * from "./SurveyListTable.vue?vue&type=script&lang=js"
import style0 from "./SurveyListTable.vue?vue&type=style&index=0&id=20452279&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20452279",
  null
  
)

export default component.exports